import React from 'react'
import CardFilter from './CardFilter'
import "./CardRender.css"

const CardRender = ({parent,loading,searchFil,name,us,pri}) => {

    return (
        <div className="card-render">
            <CardFilter parent={parent} loading={loading} searchFil={searchFil} name={name} us={us} pri={pri}/>
        </div>
    )
}

export default CardRender;
